module.exports = __webpack_public_path__ + "img/40_38_033_380.39724672.jpg";